import { useEffect } from 'react';

export default function Analytics() {
    useEffect(() => {
        // Create script elements for Google Analytics
        const createGAScript = () => {
            const script1 = document.createElement('script');
            script1.async = true;
            script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-8XJMZSBDSY';

            const script2 = document.createElement('script');
            script2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-8XJMZSBDSY');
      `;

            document.head.appendChild(script1);
            document.head.appendChild(script2);
        };

        createGAScript();

        // Track clicks on links with Google Analytics
        const trackExternalLinks = () => {
            document.addEventListener('click', (event) => {
                const target = event.target as HTMLElement;
                const link = target.closest('a');

                if (link && link.href && link.target === '_blank') {
                    // @ts-expect-error - gtag is injected by Google Analytics
                    gtag('event', 'click', {
                        'event_category': 'External Link',
                        'event_label': link.href,
                        'transport_type': 'beacon'
                    });
                }
            });
        };

        trackExternalLinks();
    }, []);

    return null;
} 